import { configureStore } from "@reduxjs/toolkit";
import chatHistorySidebarReducer from "./chatHistorySidebarSlice";
import fullScreenLoaderReducer from "./fullScreenLoaderSlice";
import chatHistoryReducer from './chatHistorySlice';
import userAccountReducer from './userAccountSlice';
// import mediaSidebarReducer from './mediaSidebarSlice';

const store = configureStore({
	reducer: {
    	sidebar: chatHistorySidebarReducer, // Register the sidebar reducer
    	fullScreenLoader: fullScreenLoaderReducer, // Register the sidebar reducer
    	chatHistory: chatHistoryReducer, // Register the chatHistory reducer
    	userAccount: userAccountReducer, // Register the Account setting details reducer
    	// mediaSidebar: mediaSidebarReducer,
	},
});

export default store;
